export enum UIPanelEvent {
    OPEN_SETTINGS = 'uiSettingsOpen',
    CLOSE_SETTINGS = 'uiSettingsClose',
    OPEN_PANEL = 'uiPanelOpen',
    CLOSE_PANEL = 'uiPanelClose',
    SHOW_POPUP = 'uiPopupShow',
    HIDE_POPUP = 'uiPopupHide'
}
